/*
 * PROD-7828 R10 — how the Reports tab answers each published error code (read through the module's
 * one reader, CD-128). error_handlers.test.js proves every code in reports_enums.json is handled here
 * or named as an audit-only code.
 */
import { api_error, is_permission_error } from '../format';
import { blockers_view } from './adapters';

export const HANDLER_BLOCKED = 'blocked'; // "D97": show the blockers and "Recalculate now"
export const HANDLER_NO_DATA = 'no_data'; // R10-C16: the month has no teacher rows
export const HANDLER_PERMISSION = 'permission'; // the shell's no-permission page
export const HANDLER_RETRY = 'retry'; // a failed read: say so and offer a retry
export const HANDLER_REFUSED = 'refused'; // a request the server will never accept as sent

export const REPORT_ERROR_HANDLERS = {
  REPORT_BLOCKED: HANDLER_BLOCKED,
  NO_MONTH_DATA: HANDLER_NO_DATA,
  FORBIDDEN: HANDLER_PERMISSION,
  LOOKUP_FAILED: HANDLER_RETRY,
  INVALID_PAY_MONTH: HANDLER_REFUSED,
  UNKNOWN_REPORT: HANDLER_REFUSED,
  INVALID_REQUEST: HANDLER_REFUSED
};

// Answered only by the audit routes; the audit browser (audit/**) handles them.
export const AUDIT_ONLY_CODES = {
  AUDIT_FILTER_REQUIRED: 'an audit query with neither a month nor a teacher',
  INVALID_PAGINATION: 'the audit list page size or keyset',
  TEACHER_NOT_FOUND: 'an audit link naming no teacher',
  BAD_SORT: 'an audit list sort key or direction outside AuditSortKeys'
};

const FALLBACK_TEXT = {
  [HANDLER_BLOCKED]: 'Some teachers need recalculation before this month can be reported.',
  [HANDLER_NO_DATA]: 'No teacher has payment data for this month.',
  [HANDLER_RETRY]: 'Could not load the report. Try again.',
  [HANDLER_REFUSED]: 'The server refused this report request.'
};

// A 401/403 is a permission error whatever its body says; an unknown code or a dropped
// connection is a retry.
export const report_error = (e) => {
  const { code, message } = api_error(e);
  const handler = is_permission_error(e)
    ? HANDLER_PERMISSION
    : REPORT_ERROR_HANDLERS[code] || HANDLER_RETRY;
  const body = (e && e.response && e.response.data) || {};
  return {
    code,
    handler,
    message: message || FALLBACK_TEXT[handler] || '',
    blockers: handler === HANDLER_BLOCKED ? blockers_view(body.blockers) : []
  };
};
